import IncentiveCapSummary from "./IncentiveCapSummary.vue";

const list = {
  // 목록 상단(좌측)에 "연도별 인센티브 Cap" 버튼 표시 (tab-items 의 visibleTotalCount: true 필요)
  summaryComponent: IncentiveCapSummary,

  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장명",
        value: "사업장명",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: "",
        },
      },
      {
        component: "search-start-end",
        label: "집계기간",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-keyword",
        label: "부서명",
        value: "부서명",
        query: { dept: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-keyword",
        label: "이름",
        value: "이름",
        query: { nm: "keyword" },
        options: {
          default: "",
        },
      },
    ];
  },

  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 연도 (발급일자 기준 — 1227 집계와 동일)
    if (search.year) {
      conditions.push({ key: "body.발급일자", operator: "LIKE", value: `${search.year}-%` });
    }

    // 사업장명
    if (search.사업장명 && search.사업장명.fieldName) {
      conditions.push({ key: "body.stdInfo.field_name", operator: "LIKE", value: `%${search.사업장명.fieldName}%` });
    }

    // 집계기간 (발급일자 범위)
    if (search.date && search.date.startDate) {
      conditions.push({ key: "body.발급일자", operator: ">=", value: search.date.startDate });
    }
    if (search.date && search.date.endDate) {
      conditions.push({ key: "body.발급일자", operator: "<", value: new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") });
    }

    // 부서명
    if (search.부서명) {
      conditions.push({ key: "body.대상자.부서명", operator: "LIKE", value: `%${search.부서명}%` });
    }

    // 이름
    if (search.이름) {
      conditions.push({ key: "body.대상자.이름", operator: "LIKE", value: `%${search.이름}%` });
    }

    return conditions;
  },

  // 결재완료(승인)된 문서만 목록에 표시
  getOptions: () => {
    return {
      statusIds: [4],
    };
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "연도", key: "body.발급일자", style: { width: "70px" } },
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "부서명", key: "body.대상자.부서명" },
      { name: "파트명", key: "body.대상자.파트명" },
      { name: "이름", key: "body.대상자.이름" },
      { name: "직급", key: "body.대상자.직급" },
      { name: "등급", key: "body.등급" },
      { name: "발급일자", key: "body.발급일자" },
      { name: "발급유형", key: "body.발급유형" },
      { name: "세부내용", key: "body.세부설명", style: { minWidth: "200px" }, textDisplay: "wrap" },
    ];
  },

  getCol: (index, value, func) => {
    try {
      const body = func.getContent(value);
      const 대상자 = body.대상자 || {};
      let i = 0;
      if (index === i++) return (body.발급일자 || "").substring(0, 4); // 연도 = 발급일자 기준
      if (index === i++) return (body.stdInfo && body.stdInfo.field_name) || "";
      if (index === i++) return 대상자.부서명 || "";
      if (index === i++) return 대상자.파트명 || "";
      if (index === i++) return 대상자.이름 || "";
      if (index === i++) return 대상자.직급 || "";
      if (index === i++) {
        const colors = { 개선: "#6da9e8", 우수: "#e0b25a", 탁월: "#e26b6b" };
        if (body.등급 && colors[body.등급]) {
          return { type: "colorBox", color: colors[body.등급], text: body.등급 };
        }
        return body.등급 || "";
      }
      if (index === i++) return body.발급일자 || "";
      if (index === i++) return body.발급유형 || "";
      if (index === i++) return body.세부설명 || "";
    } catch (e) {
      /* ignore */
    }
    return "";
  },

  // 등급별 행 배경색 (1229 안전위반통보서와 동일한 패턴)
  getRowClass: (value) => {
    try {
      const body = JSON.parse(value.post_content).body;
      if (body.등급 === "개선") return "grade-improve";
      if (body.등급 === "우수") return "grade-good";
      if (body.등급 === "탁월") return "grade-excellent";
    } catch (e) {
      /* ignore */
    }
  },
  addRowClassStyles: () => {
    const styleId = "safety-card-row-styles";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
         html body .vs-table tr.grade-improve td,
         html body .vs-table tr.grade-improve td.sticky-column {
           background-color: #eaf2fc !important;
         }
         html body .vs-table tr.grade-good td,
         html body .vs-table tr.grade-good td.sticky-column {
           background-color: #fdf3e2 !important;
         }
         html body .vs-table tr.grade-excellent td,
         html body .vs-table tr.grade-excellent td.sticky-column {
           background-color: #fdecec !important;
         }

         html body .vs-table tr.grade-improve:hover td,
         html body .vs-table tr.grade-improve:hover td.sticky-column {
           background-color: #dcebfa !important;
         }
         html body .vs-table tr.grade-good:hover td,
         html body .vs-table tr.grade-good:hover td.sticky-column {
           background-color: #fae9cf !important;
         }
         html body .vs-table tr.grade-excellent:hover td,
         html body .vs-table tr.grade-excellent:hover td.sticky-column {
           background-color: #fadddd !important;
         }

         .vs-table tr:hover {
          transform: translateY(0);
         }
       `;
      document.head.appendChild(style);
    }
  },

  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
};

export default list;
